import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '\"Playfair Display\", serif' }}>
              Perfect Stitch&Style Alterations
            </h3>
            <p className="text-sm mb-4">
              Premium mobile alteration services in New Jersey. We bring expert tailoring directly to your home across Jersey Shore, Long Branch, Brick, Newark, Jersey City and surrounding areas.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-amber-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-amber-700 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-amber-700 transition-colors cursor-pointer">
                <i className="ri-pinterest-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-amber-500 transition-colors cursor-pointer">Home</Link></li>
              <li><Link to="/services" className="hover:text-amber-500 transition-colors cursor-pointer">Services</Link></li>
              <li><Link to="/pricelist" className="hover:text-amber-500 transition-colors cursor-pointer">Price List</Link></li>
              <li><Link to="/about" className="hover:text-amber-500 transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-amber-500 transition-colors cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Wedding Dress Alterations</li>
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Suit Tailoring</li>
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Hem Adjustments</li>
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Custom Fitting</li>
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Zipper Replacement</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-amber-500 mt-1 mr-3"></i>
                <span className="text-sm">Serving New Jersey & surrounding areas</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-amber-500 mr-3"></i>
                <span className="text-sm">(908) 560-2447</span>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line text-amber-500 mr-3"></i>
                <span className="text-sm">style.stitchalterations25@gmail.com</span>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-amber-500 mt-1 mr-3"></i>
                <div className="text-sm">
                  <p>Mon-Fri: 9AM - 7PM</p>
                  <p>Sat: 10AM - 6PM</p>
                  <p>Sun: By Appointment</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Perfect Stitch&Style Alterations. All rights reserved.</p>
          <p className="mt-2">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-amber-500 transition-colors cursor-pointer">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
